import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import { injectIntl, intlShape } from 'react-intl';
import { Breadcrumb, BreadcrumbItem } from 'reactstrap';
import Layout from '../../components/Layout/Layout';
import Card from '../../components/Card/Card';
import StatisticsPage from '../statistics/StatisticsPage';
import { getSlaveId } from '../../components/Statistics/statisticsHelpers';
import DeleteMemberBlock from '../../components/MasterAccount/DeleteMemberBlock';
import FinancesPage from '../finances/FinancesPage';
import PaymentDataPage from '../payment/PaymentDataPage';
import { startSetSlaves } from '../../actions/slaves';
import { resetStatFilters } from '../../actions/statistics';
import { iFMessage, FMessage } from '../../hoc/IntlComponents';
import WithAlert from '../../hoc/WithAlert';
import DeleteMemberModal from '@modals/DeleteMemberModal/DeleteMemberModal';

const navTitles = (intl) => ({
  statistics: iFMessage({ id: 'pages.statistics.title', intl }),
  finances: iFMessage({ id: 'pages.payments.title', intl }),
  paymentsData: iFMessage({ id: 'slaves.tabs.payments-data', intl }),
});

const navs = (intl) => [
  <a className="nav-link" title={navTitles(intl).statistics}>
    {navTitles(intl).statistics}
  </a>,
  <a className="nav-link" title={navTitles(intl).finances}>
    {navTitles(intl).finances}
  </a>,
  <a className="nav-link" title={navTitles(intl).paymentsData}>
    {navTitles(intl).paymentsData}
  </a>,
];

class GeneralStatisticsPage extends Component {
  static propTypes = {
    intl: intlShape.isRequired,
  };

  state = {
    loading: true,
    errors: {},
    isModalOpen: false,
  };

  componentDidMount() {
    const { slaves, startSetSlaves } = this.props;
    if (slaves === undefined) {
      startSetSlaves();
    }
  }

  getTitle = () => {
    const { slaves } = this.props;
    const slaveId = getSlaveId();
    if (slaves === undefined) {
      return slaveId;
    }
    const slave = slaves !== undefined && slaves.find((slave) => slave.id == slaveId);
    return slave ? slave.title : slaveId;
  };

  setLoading = (bool) => {
    this.setState(() => ({ loading: bool }));
  };

  getSlaveBalance = () => {
    const { balance } = this.props;
    return <SlaveBalanceData balance={balance} />;
  };

  componentWillUnmount() {
    this.props.resetStatFilters();
  }

  toggleModal = () => {
    this.setState((prev) => ({ isModalOpen: !prev.isModalOpen }));
  };

  render() {
    const { intl, showAlert, history, slaves, balance } = this.props;
    const { isModalOpen } = this.state;

    return (
      <>
        <Layout title="Просмотр аккаунта">
          <Layout.Col className="master-account">
            <Card>
              <Card.Header className="master-account-header">
                <div className="master-account-header-innner">
                  <Breadcrumb>
                    <BreadcrumbItem>
                      <Link to="/tools/master?template=7">
                        <FMessage id="navigation.master.main" />
                      </Link>
                    </BreadcrumbItem>
                    <BreadcrumbItem active>
                      <FMessage id="slaves.general-page.header" />
                    </BreadcrumbItem>
                  </Breadcrumb>
                </div>
              </Card.Header>
              <DeleteMemberBlock
                balance={balance}
                slaves={this.getTitle()}
                onClick={this.toggleModal}
              />
              <Card.Header>
                <FMessage id="slaves.general-page.header" />
              </Card.Header>
              <Card.NavTabs
                navItems={navs(intl)}
                showAlert={showAlert}
                className="master-account-navtabs"
              >
                <StatisticsPage
                  isMember
                  location={history.location}
                  className="member-statistics"
                />
                <FinancesPage isMember history={history} className="finances-card" />
                <PaymentDataPage isMember className="member-payment-data" />
              </Card.NavTabs>
            </Card>
          </Layout.Col>
        </Layout>

        {isModalOpen && (
          <DeleteMemberModal
            isOpen={isModalOpen}
            handleClose={this.toggleModal}
            balance={balance}
            slaves={this.getTitle()}
          />
        )}
      </>
    );
  }
}

const mapStateToProps = ({ slaves }) => ({
  slaves: slaves.ids,
  balance: slaves.balance,
});

const mapDispatchToProps = (dispatch) => ({
  startSetSlaves: () => dispatch(startSetSlaves()),
  resetStatFilters: () => dispatch(resetStatFilters()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withRouter(injectIntl(WithAlert(GeneralStatisticsPage))));
